"use strict";

function _typeof2(obj) { "@babel/helpers - typeof"; return _typeof2 = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof2(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _typeof(obj) {
  if (typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol") {
    _typeof = function _typeof(obj) {
      return _typeof2(obj);
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : _typeof2(obj);
    };
  }

  return _typeof(obj);
}

function checkUseOfModifier(modifier, modifiersProp) {
  if (typeof modifiersProp === 'string') {
    return modifiersProp === modifier;
  }

  if (Array.isArray(modifiersProp)) {
    return modifiersProp.includes(modifier);
  }

  return false;
}
/**
 * A proptypes utility for evaluating the use of a modifier. Given a modifier value and the
 * modifier prop, will return true if the modifier value is being used.
 *
 * @template ModifierConfig
 * @param {keyof ModifierConfig} modifier
 * @param {ModifiersProp<ModifierConfig, typeof sizes>} [modifiersProp]
 * @param {keyof typeof sizes} [size]
 * @returns {boolean}
 */


function modifiersPropApplies(modifier, modifiersProp, size) {
  if (!modifiersProp) {
    return false;
  }

  if (_typeof(modifiersProp) === 'object' && !Array.isArray(modifiersProp) && size) {
    // Modifiers prop is being used responsively.
    return checkUseOfModifier(modifier, modifiersProp[size]);
  } // Modifiers prop is not being used responsively.


  return checkUseOfModifier(modifier, modifiersProp);
}

var _default = modifiersPropApplies;
exports.default = _default;